/**
 * Normaliza o `enrollmentId` que vai para o GraphQL.
 *
 * Na visão do produtor não existe matrícula, e a URL `/admin_view/...` não tem
 * o segmento. Duas armadilhas apareceram por causa disso:
 *
 * - `Number(undefined)` é `NaN`, que o `JSON.stringify` serializa como `null` →
 *   "Variable $enrollmentId of type ID! was provided invalid value".
 * - o sentinela `0`/`'0'` que vários componentes usam **não** é blank em Ruby,
 *   então o servidor tenta `Enrollment.find(0)` e devolve not_found.
 *
 * Devolver `undefined` faz o `JSON.stringify` remover a variável do payload, e
 * aí o argumento (opcional no schema) simplesmente não chega — que é o caso do
 * preview. Aluno continua mandando o id de verdade.
 */
/** O que os call sites realmente têm em mãos (useLocalSearchParams inclusive). */
export type OptionalEnrollmentId = string | string[] | number | null | undefined

export const optionalEnrollmentId = (
  value: OptionalEnrollmentId,
): string | undefined => {
  const raw = Array.isArray(value) ? value[0] : value

  if (raw === null || raw === undefined) return undefined
  if (typeof raw === 'number' && !Number.isFinite(raw)) return undefined

  const asString = `${raw}`

  if (asString === '' || asString === '0' || asString === 'NaN') {
    return undefined
  }

  return asString
}
